import { AuthenticatedUserModel } from "@courses-utils/gateway-auth";

import { ElementModel } from "@courses-pm2/api/src/ts/models";
import { Engine } from "@courses-pm2/api/src/ts/utils";

import { parseAccordion } from "@courses-pm2/api/src/ts/parser/elements/parseAccordion";
import { parseAudio } from "@courses-pm2/api/src/ts/parser/elements/parseAudio";
import { parseGrid } from "@courses-pm2/api/src/ts/parser/elements/parseGrid";
import { parseIframe } from "@courses-pm2/api/src/ts/parser/elements/parseIframe";
import { parseImage } from "@courses-pm2/api/src/ts/parser/elements/parseImage";
import { parsePlaceholder } from "@courses-pm2/api/src/ts/parser/elements/parsePlaceholder";
import { parseRichtext } from "@courses-pm2/api/src/ts/parser/elements/parseRichtext";
import { parseSlider } from "@courses-pm2/api/src/ts/parser/elements/parseSlider";
import { parseVideo } from "@courses-pm2/api/src/ts/parser/elements/parseVideo";
import { parseCallToActionCards } from "./elements/parseCallToActionCards";
import { parseSplit } from "./elements/parseSplit";
import { parseGlossaryCollection } from "./elements/parseGlossaryCollection";

/**
 * Helper that'll propagate parsing of PM2 components to the proper methods
 * depending on the type of node given.
 */
export async function parseElement(args: {
  node: Element;
  portalId: string;
  user?: AuthenticatedUserModel;
  engine?: Engine;
}): Promise<ElementModel | undefined> {
  switch (args.node.tagName.toLowerCase()) {
    case "accordion":
      return parseAccordion(args);

    case "audio":
      return parseAudio(args);

    case "complexcontent":
      return parseRichtext(args);

    case "component":
      return parseIframe(args);

    case "ibook":
    case "ibook3":
      return parseIframe(args);

    case "ibook4":
      return parseIframe(args);

    case "image":
      return parseImage(args);

    case "iframe":
      return parseIframe(args);

    case "taskenginelink":
      return parseIframe(args);

    case "placeholder":
      return parsePlaceholder(args);

    case "richtext":
      return parseRichtext(args);

    case "rows":
      return parseGrid(args);

    case "simpletext":
      return parseRichtext(args);

    case "slider":
      return parseSlider(args);

    case "textimage":
      return parseSplit(args);

    case "glossarycollection":
      return parseGlossaryCollection(args);

    case "video":
      return parseVideo(args);

    case "calltoactioncardcontainer":
      return parseCallToActionCards(args);

    default:
      // No other kinds of nodes are supported
      return undefined;
  }
}
